export default __webpack_public_path__ + "static/media/location-mobile.0074f375.png";